import React from "react";

const Quote = () => {
    return (
        <div className="text-center lg-xl:my-20 lg:my-15 my-10 w-full px-20px max-w-[1176px] mx-auto">
            <p className="mb-2.5 font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] text-black tracking-normal uppercase font-fira">
                "THE PRICE GOOD MEN PAY FOR INDIFFERENCE TO PUBLIC AFFAIRS IS TO BE RULED BY EVIL MEN."
            </p>
            <span className="text-22px leading-[35.2px] tracking-normal font-fira font-normal">
                -PLATO
            </span>
        </div>
    );
};

export default Quote;